<template>
  <Select :value="value" @input="$ev => $emit('input', $ev)" v-bind="$attrs" dir="rtl">
    <option v-for="(item, index) in items" :value="item.value" :disabled="item.disabled" :key="index" dir="ltr">
      {{ item.label }}
    </option>
  </Select>
</template>

<script>
import Select from '@/components/Select/Select'

export default {
  props: {
    value: [String, Boolean],
    items: Array,
  },
  components: {
    Select,
  },
}
</script>
